import {
  Component,
  Inject,
  OnInit,
  Optional,
  ViewChild,
  inject,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import "lodash";
import { DataService } from "src/app/data.service";
declare var _: any;
import { CustomersService } from "src/app/customers/customers.service";
import { ColumnState, GridReadyEvent } from "ag-grid-community";
import { AuthService } from "src/app/auth.service";

@Component({
  selector: "app-customer-dialog",
  templateUrl: "./customer-dialog.component.html",
  styleUrls: ["./customer-dialog.component.css"],
})
export class NewCustomerDialogComponent implements OnInit {
  _authService = inject(AuthService);
  selectedCustomerGroupId: number = this._dataService.customerGroups().length
    ? this._dataService.customerGroups()[0].id
    : null;
  @ViewChild("inv") form;
  dataLoading: boolean = false;
  customerName: string;
  details: string;
  addBalance: string;
  initialBalance: number = 0;
  customerBalance: number = 0;
  customerBalanceEdited: number = 0;
  showOperations: boolean = false;
  showAllOperations: boolean =
    this._dataService.getLS("showAllCustomerOperations") ?? false;
  agGridData$;
  addBalanceInputFocused: boolean = false;
  columnDefs = [
    {
      headerName: "id",
      field: "id",
      hide: true,
    },
    {
      headerName: "sequence",
      field: "sequence",
      hide: true,
    },
    {
      headerName: "Əməliyyat Tipi",
      field: "type",
      flex: 3,
      minWidth: 100,
      cellRenderer: (params) => {
        switch (params.value) {
          case "Bank":
            return params.data.sum < 0 ? "Kassa Məxaric" : "Kassa Mədaxil";
          case "Return":
            return "Qaytarma";
          case "Sells":
            return "Satış";
          case "Stock Entry":
            return "Anbar Giriş";
          case "Stock Out":
            return "Anbar Çıxış";
          case "Production":
            return "İstehsalat";
          case "Salary":
            return "Maaş";
          case "InitialBalance":
            return "Başlanğıc";
          default:
            return params.value;
        }
      },
    },
    {
      headerName: "Məbləğ",
      field: "sum",
      flex: 3,
      minWidth: 100,
      cellRenderer: (params) => {
        if (params.value === null || params.value === undefined) return '';
        return params.value < 0 ? -params.value : params.value;
      },
    },
    {
      headerName: "Tarix",
      field: "date",
      flex: 3,
      minWidth: 100,
      comparator: (valueA, valueB, nodeA, nodeB) => {
        // Always sort by sequence to maintain chronological order
        return nodeA.data.sequence - nodeB.data.sequence;
      },
    },
    {
      headerName: "Balans",
      field: "runningBalance",
      flex: 3,
      minWidth: 100,
      cellRenderer: (params) => {
        return params.value !== undefined ? params.value.toFixed(2) : '0.00';
      },
    },
  ];
  gridApi: any;
  constructor(
    public dialogRef: MatDialogRef<NewCustomerDialogComponent>,
    private http: HttpClient,
    private toastr: ToastrService,
    public _dataService: DataService,
    protected _customersService: CustomersService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    // effect(() => {
    //   this._dataService.customers();
    //   // this.calculateBalance();
    // });
  }

  async ngOnInit() {
    if (this.dialogData?.data?.name) {
      let customerDetails = this._dataService
        .customers()
        .find((c) => c.id == this.dialogData.data.id);
      this.selectedCustomerGroupId = customerDetails.customerGroupId;
      this.details = customerDetails.details;
      this.customerName = this.dialogData.data.name;
      this.initialBalance = customerDetails.balance || 0;
    }

    if (this.dialogData?.data?.customerGroupId) {
      this.selectedCustomerGroupId = this.dialogData?.data?.customerGroupId;
    }
    if (this.dialogData?.data?.customerGroupId && !this.dialogData.data.id) {
      this.dialogData.data = null;
    }
    if (this.dialogData.data?.customerData?.finalBalance) {
      this.customerBalance = this.dialogData.data.customerData.finalBalance;
      this.customerBalanceEdited =
        this.dialogData.data.customerData.finalBalance;
    } else if (
      this.dialogData?.data?.name &&
      !this.dialogData.data?.customerData?.finalBalance
    ) {
      (
        await this._customersService.getCustomersBalanceById(
          this.dialogData.data.id
        )
      ).subscribe((r) => {
        let customerBalaceObj = r.find(
          (c) => c.customerId == this.dialogData.data.id
        );
        this.customerBalance = customerBalaceObj.finalBalance;
        this.customerBalanceEdited = customerBalaceObj.finalBalance;
      });
    }
  }

  addCustomer(formData, event) {
    event.srcElement.disabled = true;
    event.target.innerText = "Gözləyin ...";
    // CHECK IF DATA ALREADY EXISTS IN TABLE
    if (
      _.filter(this._dataService.customers(), (a) => {
        return a.name.toLowerCase() == formData.name.toLowerCase();
      }).length &&
      !this.dialogData?.data
    ) {
      this.toastr.error("", "Bu adda müştəri mövcuddur!", {
        toastClass: "ngx-toastr",
        progressBar: true,
        timeOut: 2500,
        progressAnimation: "increasing",
      });

      event.target.innerText = "Əlavə et";
      event.target.disabled = false;

      return;
    }

    let httpData = this.dialogData?.data?.name
      ? this.http.put(
          this._dataService.dbBase +
            "api.php/records/customers/" +
            this.dialogData?.data.id,
          formData
        )
      : this.http.post(
          this._dataService.dbBase + "api.php/records/customers",
          formData
        );

    formData.details = formData.details ? formData.details : "";

    return httpData.subscribe({
      next: (res) => {
        formData.id = res;

        if (this.dialogData?.data?.name) {
          formData.id = this.dialogData.data.id;
          const index = this._dataService
            .customers()
            .findIndex((obj) => obj.id === this.dialogData.data.id);
          this._dataService.customers.set([...this._dataService.customers()]);
          // TODO THIS WAS SIGNAL MUTATE
          this._dataService.customers()[index] = {
            ...formData,
            balance: this.dialogData?.data?.balance || null,
          };

          this._dataService.customers.set([...this._dataService.customers()]);
          this.toastr.success("", "Yeniləndi!", {
            toastClass: "ngx-toastr customToast",
            progressBar: true,
            timeOut: 2500,
            progressAnimation: "increasing",
          });
        } else {
          formData.id = res;
          this._dataService.customers.set([
            ...this._dataService.customers(),
            formData,
          ]);
          this.toastr.success("", "Əlavə edildi!", {
            toastClass: "ngx-toastr customToast",
            progressBar: true,
            timeOut: 2500,
            progressAnimation: "increasing",
          });
        }
        this.dialogRef.close(formData);
        this._dataService.setLS("customers", this._dataService.customers());
      },
      error: (err) => {
        this.dialogRef.close();
        this.toastr.error("", "Xəta baş verdi!", {
          toastClass: "ngx-toastr",
          progressBar: true,
          timeOut: 2500,
          progressAnimation: "increasing",
        });
      },
    });
  }

  setInitialBalance(type: string, btn) {
    let btnText = btn.innerText;
    btn.innerText = "Gözləyin..";
    btn.disabled = true;

    let cbEdited =
      type == "borc" ? -this.customerBalanceEdited : this.customerBalanceEdited;
    let addedBalance: number = cbEdited - this.customerBalance;
    let resultBalance = this.initialBalance + addedBalance;
    if (type == "sifirla") {
      resultBalance = this.initialBalance - this.customerBalance;
      this.customerBalance = 0;
    }
    this.http
      .put(
        this._dataService.dbBase +
          "api.php/records/customers/" +
          this.dialogData?.data.id,
        { balance: resultBalance }
      )
      .subscribe({
        complete: () => {
          const index = this._dataService
            .customers()
            .findIndex((obj) => obj.id === this.dialogData.data.id);

          this._dataService.customers()[index].balance = resultBalance;
          this._dataService.customers.set([...this._dataService.customers()]);

          this.dialogData.data.balance = resultBalance;
          this.customerBalance =
            type == "borc"
              ? this.customerBalance - addedBalance
              : this.customerBalance + addedBalance;
          btn.innerText = btnText;
          btn.disabled = false;
          this.toastr.success("", "Uğurlu!", {
            toastClass: "ngx-toastr customToast",
            progressBar: true,
            timeOut: 2500,
            progressAnimation: "increasing",
          });
          if (type == "sifirla") {
            this.customerBalanceEdited = 0;
          }
        },
        error: () => {
          this.toastr.error("", "Xəta baş verdi, yenidən cəhd edin", {
            toastClass: "ngx-toastr",
            progressBar: true,
            timeOut: 2500,
            progressAnimation: "increasing",
          });
        },
      });
  }

  async customerOperations() {
    this.dataLoading = true;
    const operations = await this._customersService.getCustomerOperations(
      this.dialogData.data.id,
      this.showAllOperations
    );
    
    // Calculate running balance
    // Sort by date ascending first to calculate balance correctly
    const sortedOps = [...operations].sort((a, b) => {
      const dateCompare = new Date(a.date).getTime() - new Date(b.date).getTime();
      if (dateCompare !== 0) return dateCompare;
      
      // For same-date transactions, use dateAdded if available
      if (a.dateAdded && b.dateAdded) {
        const dateAddedCompare = new Date(a.dateAdded).getTime() - new Date(b.dateAdded).getTime();
        if (dateAddedCompare !== 0) return dateAddedCompare;
      }
      
      // Finally use id as tiebreaker
      return a.id - b.id;
    });
    
    // Calculate the starting balance
    // When showAllOperations is false, we need to calculate balance from transactions before startDate
    let runningBalance = 0;
    
    if (this.showAllOperations) {
      // When showing all operations, start from initialBalance
      runningBalance = this.initialBalance || 0;
    } else {
      // When filtering by date, start from customerBalance minus the balance changes in the current period
      // This ensures the last transaction's running balance matches customerBalance
      runningBalance = this.customerBalance || 0;
      
      // Calculate the balance change from the filtered operations
      sortedOps.forEach(op => {
        if (op.type === 'Sells') {
          runningBalance -= op.sum;
        } else if (op.type === 'Return') {
          runningBalance += op.sum;
        } else if (op.type === 'Stock Entry' || op.type === 'Stock Out') {
          runningBalance += op.sum;
        } else if (op.type === 'Bank' && op.includeInBalance) {
          runningBalance += op.sum;
        } else if (op.type === 'Production' || op.type === 'Salary') {
          runningBalance += op.sum;
        } else {
          runningBalance -= op.sum;
        }
      });
    }
    
    // Add initial balance row if there is one and showAllOperations is true
    const allOps = [];
    if (this.showAllOperations && this.initialBalance && this.initialBalance !== 0) {
      allOps.push({
        id: 'initial-balance',
        type: 'InitialBalance',
        sum: this.initialBalance,
        date: '*',
        runningBalance: this.initialBalance,
        isInitialBalance: true,
        sequence: 0
      });
    }
    
    const opsWithBalance = sortedOps.map((op, index) => {
      // Flatten the nested transactionId object for Bank transactions
      let flattenedOp = { ...op };
      if (op.transactionId && typeof op.transactionId === 'object') {
        // Merge transactionId properties into the main object
        flattenedOp = {
          ...op.transactionId,
          ...op,
          // Keep the original id from transactionId as the main id
          id: op.transactionId.id,
          // Keep the bank table id as bankId
          bankId: op.id
        };
        delete flattenedOp.transactionId;
      }
      
      // Balance formula: sells - stocks - income + outgoings
      if (flattenedOp.type === 'Sells') {
        // Customer bought items, they owe us more
        runningBalance += flattenedOp.sum;
      } else if (flattenedOp.type === 'Return') {
        // Customer returned items, reduces their debt
        runningBalance -= flattenedOp.sum;
      } else if (flattenedOp.type === 'Stock Entry' || flattenedOp.type === 'Stock Out') {
        // We bought from customer, we owe them (reduces balance)
        runningBalance -= flattenedOp.sum;
      } else if (flattenedOp.type === 'Bank') {
        // Only include in balance if includeInBalance is truthy (1 or true)
        if (flattenedOp.includeInBalance) {
          // Bank income (positive) = they paid us (reduces what they owe)
          // Bank outgoings (negative) = we paid them (increases what they owe)
          runningBalance -= flattenedOp.sum;
        }
      } else if (flattenedOp.type === 'Production' || flattenedOp.type === 'Salary') {
        // Production/Salary payments reduce balance
        runningBalance -= flattenedOp.sum;
      } else {
        // Default: add the sum
        runningBalance += flattenedOp.sum;
      }
      
      return {
        ...flattenedOp,
        runningBalance: runningBalance,
        sequence: allOps.length + index + 1
      };
    });
    
    this.agGridData$ = [...allOps, ...opsWithBalance];
    console.log(this.agGridData$);
    this.dataLoading = false;
    this.showOperations = true;
  }

  onRowClicked(event) {
    // Don't open dialog for initial balance row
    if (event.data.isInitialBalance) {
      return;
    }
    this._dataService.transactionDialog(event.data);
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    // this.gridApi.setIncludeHiddenColumnsInQuickFilter(true);
    var defaultSortModel: ColumnState[] = [
      { colId: "sequence", sort: "desc", sortIndex: 0 },
    ];
    // this.gridApi.setGetRowClass((params) => {
    //   return params.node.data.justAdded == true ? "tableDataLoading" : "";
    // });
    // params.api.setDefaultColDef({
    //   // filter: true
    // });
    params.api.applyColumnState({ state: defaultSortModel });
  }

  print() {
    this.gridApi.setGridOption("domLayout", "print");

    // Get the data and process it with your cell renderers
    const processedData = this.getProcessedDataForPrint();

    const printWindow = window.open("", "_blank");

    printWindow?.document.write(`
    <html>
      <head>
        <title>JJ Erp</title>
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          th, td {
            border: 1px solid #ccc;
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f5f5f5;
            font-weight: bold;
          }
          .hide-column {
            display: none;
          }
          tr td:first-child {
            text-align: left;
            padding-left: 1rem;
          }
           .logo {
            font-size: 40px;
            text-decoration: none;
            font-family: 'Titan One', fantasy, sans-serif;
            line-height: 19px;
            padding-left: 50px;
            font-style: italic;
            letter-spacing: 1px;
          }
        </style>
        <link
          href="https://fonts.googleapis.com/css2?family=Titan+One&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        <div style="display: flex; align-items: center; padding: 0px 20px;">
          <h1 class='logo'>JJ</h1>
          <div style="margin-inline:auto">
            <h1 style="text-align: center;">${this.customerName}</h1>
          </div>
        </div>
       
        ${this.generatePrintTable(processedData)}
      </body>
    </html>
  `);

    printWindow?.document.close();
    printWindow?.print();
    setTimeout(() => {
      this.gridApi.setGridOption("domLayout", "normal");
    }, 500);
  }

  private getProcessedDataForPrint(): any[] {
    // Get all displayed rows from the grid (already sorted by date desc)
    const allData: any[] = [];
    this.gridApi.forEachNodeAfterFilterAndSort((node: any) => {
      if (node.data) {
        allData.push(this.processRowForPrint(node.data));
      }
    });

    return allData;
  }

  private processRowForPrint(row: any): any {
    return {
      ...row,
      type: this.getProcessedType(row),
      sum: this.getProcessedSum(row),
      runningBalance: row.runningBalance !== undefined && row.runningBalance !== null 
        ? parseFloat(row.runningBalance.toFixed(2)) 
        : row.runningBalance,
    };
  }

  private getProcessedType(row: any): string {
    switch (row.type) {
      case "Bank":
        return row.sum < 0 ? "Kassa Məxaric" : "Kassa Mədaxil";
      case "Return":
        return "Qaytarma";
      case "Sells":
        return "Satış";
      case "Stock Entry":
        return "Anbar Giriş";
      case "Stock Out":
        return "Anbar Çıxış";
      case "Production":
        return "İstehsalat";
      case "Salary":
        return "Maaş";
      case "InitialBalance":
        return "Başlanğıc";
      default:
        return row.type;
    }
  }

  private getProcessedSum(row: any): number | string {
    if (row.sum === null || row.sum === undefined) return '';
    const value = row.sum < 0 ? -row.sum : row.sum;
    return parseFloat(value.toFixed(2));
  }

  private generatePrintTable(data: any[]): string {
    const headers = this.columnDefs
      .filter((col) => !col.hide)
      .map((col) => `<th>${col.headerName}</th>`)
      .join("");

    const rows = data
      .map((row) => {
        const cells = this.columnDefs
          .filter((col) => !col.hide)
          .map((col) => `<td>${row[col.field]}</td>`)
          .join("");
        return `<tr>${cells}</tr>`;
      })
      .join("");

    return `
    <table>
      <thead>
        <tr>${headers}</tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  `;
  }
}
